interface LoadingSpinnerProps {
  className?: string
}

const LoadingSpinner = ({ className }: LoadingSpinnerProps) => {
  return (
    <div className={`flex items-center justify-center min-h-screen ${className || ''}`}>
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500" />
    </div>
  )
}

export default LoadingSpinner
